// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__25PUy","range":"MonthRangeSwitch_range__13f__","disabled":"MonthRangeSwitch_disabled__3PLj0"};